import { Component, OnInit } from '@angular/core';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'bootDash';
  // title = 'jsreport-sample';
  // public serviceUrl: string;
  // public reportPath: string;

    constructor(private auth:AuthService, modalConfig: NgbModalConfig) {
        modalConfig.centered = true;
        // this.serviceUrl = 'https://demos.boldreports.com/services/api/ReportViewer';
        // this.reportPath = '~/Resources/docs/sales-order-detail.rdl';
    }
  ngOnInit(): void {
    this.auth.restoreTokenTimer();
  }
}
